/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Aml_Out_Reason_For_UseInputs */

const vi_aml_out_reason_for_use = /** @type {(inputs: Aml_Out_Reason_For_UseInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Xuất sử dụng`)
};

/**

* @param {Aml_Out_Reason_For_UseInputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
export const aml_out_reason_for_use = /** @type {((inputs?: Aml_Out_Reason_For_UseInputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Aml_Out_Reason_For_UseInputs, { locale?: "vi" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_aml_out_reason_for_use(inputs)
});